import { Modal } from "@/components/elements/Modal";
import { Select } from "@/components/elements/Select";
import { Button } from "@/components/elements/Button";
import { Stack, Typography } from "@mui/material";
import { FC, useState } from "react";
import { useEnum } from "@/api/services/global/enum";
import { ERecruitmentStatus } from "@/types/enum";
import { IconSave } from "@/assets/icons";

type TSelectTalentStatusModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: (talentStatus: number) => void;
};

const ALLOWED_TALENT_STATUSES = [ERecruitmentStatus.JOB_SEEKING, ERecruitmentStatus.OTHER_COMPANY_OFFER, ERecruitmentStatus.JOB_HUNTING_FINISHED];

export const SelectTalentStatusModal: FC<TSelectTalentStatusModalProps> = ({ open, onClose, onConfirm }) => {
  const { data: recruitmentStatusOptions } = useEnum("ERecruitmentStatus");
  const [selectedStatus, setSelectedStatus] = useState<number | string>("");

  const filteredOptions = recruitmentStatusOptions?.filter((option) => ALLOWED_TALENT_STATUSES.includes(Number(option.value))) || [];

  const handleConfirm = () => {
    if (selectedStatus) {
      onConfirm(Number(selectedStatus));
      setSelectedStatus("");
    }
  };

  const handleClose = () => {
    setSelectedStatus("");
    onClose();
  };

  return (
    <Modal isOpen={open} onClose={handleClose} width={500} title="人材ステータスの選択" enableFooter={false} preventCloseBackdrop={true}>
      <Stack gap={2} mb={2}>
        <Typography>人材ステータスはどれに変更しますか？</Typography>
        <Select
          nonControl
          options={filteredOptions}
          value={selectedStatus}
          onChange={(value) => setSelectedStatus(value)}
          placeholder="選択してください"
          clearable={false}
        />
      </Stack>
      <Stack flexDirection="row" justifyContent="space-between" gap="24px" mt={2}>
        <Button size="sm" variant="ghost" onClick={handleClose} sx={{ width: "102px" }}>
          キャンセル
        </Button>
        <Button size="sm" variant="primary" onClick={handleConfirm} disabled={!selectedStatus} startIcon={<IconSave />} sx={{ width: "88px" }}>
          保存
        </Button>
      </Stack>
    </Modal>
  );
};
